export enum EventTypeEnum {
    agendamento_criado = 'agendamento_criado',
    agendamento_confirmado = 'agendamento_confirmado',
    agendamento_cancelado_usuario = 'agendamento_cancelado_usuario',
    agendamento_cancelado_empresa = 'agendamento_cancelado_empresa',
    agendamento_faltou = 'agendamento_faltou',
    agendamento_compareceu = 'agendamento_compareceu',
    agendamento_remarcado = 'agendamento_remarcado',
    agendamento_remarcado_descontar = 'agendamento_remarcado_descontar',
    agendamento_excluido = 'agendamento_excluido',
    pdv_compra_realizada = 'pdv_compra_realizada',
    pdv_compra_excluida = 'pdv_compra_excluida',
    nps_respondido = 'nps_respondido',
    automacao_enviada = 'automacao_enviada',
    comunicacao_enviada = 'comunicacao_enviada',
    comunicacao_recebida = 'comunicacao_recebida',
    comunicacao_enviada_falhou = 'comunicacao_enviada_falhou',
    comunicacao_recebida_falhou = 'comunicacao_recebida_falhou',
    cartao_criado = 'cartao_criado',
    cartao_entrou = 'cartao_entrou',
    cartao_saiu = 'cartao_saiu',
    cartao_com_sucesso = 'cartao_com_sucesso',
    cartao_sem_resultado = 'cartao_sem_resultado',
    cartao_excluido = 'cartao_excluido',
    indica_incluido = 'indica_incluido',
    pessoa_aniversario = 'pessoa_aniversario',
    publico_entrou = 'publico_entrou',
    publico_saiu = 'publico_saiu',

    parceiro_indicado_incluido = 'parceiro_indicado_incluido',
    parceiro_indicado_excluido = 'parceiro_indicado_excluido',

    cobranca_atualizada = 'cobranca_atualizada',

    zandupay_pago = 'zandupay_pago',
    zandupay_cancelamento_agendado = 'zandupay_cancelamento_agendado',
    zandupay_cancelamento_agendado_excluido = 'zandupay_cancelamento_agendado_excluido',
}
